import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";

import CommonHeader from "../../common/components/CommonHeader";

const App = () => {
    const [currentMenu, setCurrentMenu] = useState("General");

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const menu = queryParams.get("menu");
        setCurrentMenu(menu || currentMenu);
    }, []);

    return (
        <CommonHeader
            parentSlug="easycommerce-store"
            parentLavel="Store"
            breadcumpSlug={
                currentMenu.charAt(0).toUpperCase() + currentMenu.slice(1)
            }
            isSettings={true}
        />
    );
};

const container = document.getElementById("easycommerce-settings-header");
const root = createRoot(container);
root.render(<App />);

export default App;
